import { type Ref } from 'vue';
import { type GpMenu } from '@gportal/uikit';
import { type NavigationFailure } from 'vue-router';

export default (menuInstance: Ref<InstanceType<typeof GpMenu>>) => {
  const navigateViaGpMenu = (
    $event: MouseEvent,
    navigateFn: (e?: MouseEvent) => Promise<void | NavigationFailure>,
  ) => {
    $event.preventDefault();
    menuInstance.value.hideMenuBody();
    navigateFn();
  };

  return {
    navigateViaGpMenu,
  };
};
